import React from 'react'
import { useDispatch } from 'react-redux'

import { setShowcaseRefreshTriggerKey } from '@store/actionSlices/projectConfig'

interface UtilityPropsInterface {
  refreshTriggerKeyFirebase: string
  refreshTriggerKeyLocal: string
}

const RefreshHandler = ({
  refreshTriggerKeyFirebase,
  refreshTriggerKeyLocal,
}: UtilityPropsInterface): void => {
  const dispatch = useDispatch()

  const refresh = (): void => window.location.reload()

  const refreshAppOnRefreshTriggerKeyChange = React.useCallback(() => {
    if (refreshTriggerKeyFirebase !== refreshTriggerKeyLocal) {
      dispatch(setShowcaseRefreshTriggerKey(refreshTriggerKeyFirebase))
      refresh()
    }
  }, [refreshTriggerKeyFirebase, refreshTriggerKeyLocal])

  React.useEffect(() => {
    if (refreshTriggerKeyFirebase) {
      refreshAppOnRefreshTriggerKeyChange()
    }
  }, [refreshTriggerKeyFirebase])
}

export default RefreshHandler
